import { useMutation, useQueryClient } from "@tanstack/react-query";
import { noteServices } from "./note.services";
import { NOTE_KEYS } from "./note.keys";

export const useCreateNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: noteServices.createNote,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: NOTE_KEYS.GET_NOTES(),
      });
    },
  });
};
